<template>
    <div>
        <header-tag class="header-tip" :title="'网吧概况'"></header-tag>
        <ul v-show="!loading">
            <li>
                <span>无盘：</span>
                <span v-text="noDiskLess"></span>
            </li>
            <li>
                <span>计费：</span>
                <span v-text="charge"></span>
            </li>
            <li>
                <span>实名：</span>
                <span v-text="menu"></span>
            </li>
            <li>
                <span>营销：</span>
                <span v-text="netScan"></span>
            </li>
            <li>
                <span>文化：</span>
                <span v-text="culture"></span>
            </li>
        </ul>
        <no-data
            style="height:auto;padding-top:20px;padding-bottom:20px;"
            :loading="loading"
        ></no-data>
    </div>
</template>
<script>
// tag组件
import HeaderTag from "_c/tagTitle/headerTag";
import NoData from "_c/noData/noData";
import { getBarEnv } from "@/requests/bar";
export default {
    components: {
        HeaderTag,
        NoData,
    },
    data() {
        return {
            noDiskLess: "",
            charge: "",
            menu: "",
            netScan: "",
            culture: "",
            loading: false,
        };
    },
    mounted() {
        this.init();
    },
    watch: {
        /* eslint-disable */
        $route(to, from) {
            this.init();
        },
    },
    methods: {
        init() {
            this.getInfo();
        },
        async getInfo() {
            this.loading = true;
            if (this.$route.params.id == undefined) {
                return false;
            }
            let res = await getBarEnv({
                barId: this.$route.params.id,
            });
            // this.noDiskLess = this.handleItemInfo(res["1"]);
            // this.charge = this.handleItemInfo(res["2"]);
            // this.menu = this.handleItemInfo(res["3"]);
            // this.netScan = this.handleItemInfo(res["4"]);
            // this.culture = this.handleItemInfo(res["5"]);
            this.noDiskLess = res.data.disklessBrandName
                ? res.data.disklessBrandName
                : "未知";
            this.charge = res.data.billingBrandName
                ? res.data.billingBrandName
                : "未知";
            this.menu = res.data.realNameBrandName
                ? res.data.realNameBrandName
                : "未知";
            this.netScan = res.data.marketBrandName
                ? res.data.marketBrandName
                : "未知";
            this.culture = res.data.cultureBrandName
                ? res.data.cultureBrandName
                : "未知";
            this.loading = false;
        },
        handleItemInfo(item) {
            let strArr = [];
            if (item) {
                item.forEach((item) => {
                    strArr.push(`${item.name}(${item.cnt})`);
                });
                if (item.length > 2) {
                    strArr.length = 2;
                    strArr.push("...");
                }
                return strArr.join("、");
            } else {
                return "未知";
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.header-tip {
    margin-bottom: 20px;
}
ul {
    li {
        padding-left: 4px;
        padding-bottom: 8px;
    }
}
</style>
